import { render, staticRenderFns } from "./reservation.vue?vue&type=template&id=1fbd1d20&"
import script from "./reservation.vue?vue&type=script&lang=js&"
export * from "./reservation.vue?vue&type=script&lang=js&"
import style0 from "./reservation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports